import { NgModule } from '@angular/core';
import { AngularFireModule, FIREBASE_OPTIONS } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { AuthenticationService } from 'src/app/auth/authentication.service';
import { FsService } from 'src/app/services/fs.service';

export function initializeApp(appConfig: FsService) {
  return appConfig.getConfig();
}
@NgModule({
  declarations: [],
  exports: [AngularFireModule, AngularFireAuthModule, AngularFirestoreModule],
  imports: [AngularFireModule, AngularFireAuthModule, AngularFirestoreModule],
  providers: [
    FsService,
    AuthenticationService,
    {
      provide: FIREBASE_OPTIONS,
      deps: [FsService],
      useFactory: initializeApp
    }
  ]
})
export class FirebaseModule {}
